import { render, staticRenderFns } from "./ResultUpdates.vue?vue&type=template&id=683e25ff"
import script from "./ResultUpdates.vue?vue&type=script&lang=js"
export * from "./ResultUpdates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports